module.exports = __webpack_public_path__ + "img/3.b9a8ad8e.png";